import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import initialItems from '../data/menu.json';
import updates from '../data/change-log.json';
import Avatar from './Avatar';
import packageJson from "../../package.json"
import { useIdleTimer } from 'react-idle-timer';
import { fetchAndActivate, getValue } from "firebase/remote-config";
import { remoteConfig } from '../helpers/remoteConfig';
import { Modal } from 'react-bootstrap'
import GreenPhoxIcon from './GreenPhoxIcon';
import { handleApiError } from '../helpers';
import StarPhoxIcon from './StarPhoxIcon';



export const LeftMenu = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const [showTimer, setShowTimer] = useState(false)
	const [seconds, setSeconds] = useState(59);
	const [versionUpdateModal, showVersionUpdateModal] = useState(false)
	const [newVersion, setNewVersion] = useState();
	const [items, setItems] = useState(initialItems);
	const myShipper = useSelector((state) => state.slice.SHIPPER);

	useEffect(() => {
		fetchAndActivate(remoteConfig)
			.then(() => {
				const { _value } = getValue(remoteConfig, "SHIPPER_WEB_VERSION");
				setNewVersion(_value);

				const lastKnownVersion = localStorage.getItem("lastKnownVersion");

				if (!lastKnownVersion || lastKnownVersion !== _value) {
					showVersionUpdateModal(true);
					localStorage.setItem("lastKnownVersion", _value);
				}
			})
			.catch(handleApiError);
	}, []);

	useEffect(() => {
		const interval = setTimeout(() => {
			if (showTimer && seconds > 0) {
				setSeconds(seconds - 1);
			}
		}, 1000);
		return () => clearTimeout(interval);
	}, [seconds, showTimer]);

	const onIdle = () => {
		setShowTimer(true)
	}

	const onActive = () => {
		setShowTimer(false)
		setSeconds(59);
	}

	useIdleTimer({ onIdle, onActive, timeout: 840_000, throttle: 500 })




	return (
		<>
			<nav className='navbar navbar-vertical fixed-start navbar-expand-md navbar-light' id='sidebar'>
				<div className='container-fluid'>
					<button className='navbar-toggler' type='button' data-toggle='collapse' data-target='#sidebarCollapse' aria-controls='sidebarCollapse' aria-expanded='false' aria-label='Toggle navigation'>
						<span className='navbar-toggler-icon'></span>
					</button>

					<Link to='/today' className='navbar-brand p-0'>
						<div className='text-center'>
							<img src='/img/logo.svg' alt='logo' className='img-fluid pb-1' style={{ width: '180px' }} />
						</div>
					</Link>

					<hr className='navbar-divider my-3' />
					<div className='collapse navbar-collapse d-flex justify-content-between' id='sidebarCollapse'>
						<ul className='navbar-nav '>
							{
								items.map(item => {
									return (
										item.id == "star-phox" ?
											<li className='nav-item' key={item?.id}>
												<Link to={item.path} className='nav-link' target={item?.target}>
													<StarPhoxIcon
														name={item.name}
													/>
												</Link>
											</li>
											:
											<React.Fragment key={item?.id}>
												{
													item?.items ?
														<li className='nav-item'>
															<a className='nav-link collapsed' href={`#${item?.id}`} data-bs-toggle='collapse' role='button' aria-expanded='false' aria-controls={item?.id}>
																<i className={`fe fe-${item.icon}`}></i> {item.name}
															</a>
															<div className='collapse show' id={item?.id}>
																<ul className='nav nav-sm flex-column'>
																	{
																		item?.items.map((submenu) => {
																			return (

																				<li className='nav-item' key={submenu.id}>
																					<Link to={submenu.path} className='nav-link'>
																						<i className={`fe fe-${submenu.icon}`}></i>{submenu.name}
																					</Link>
																				</li>

																			)
																		})
																	}
																</ul>
															</div>
														</li> :
														<li className='nav-item' key={item?.id}>
															<Link to={item.path} className='nav-link' target={item?.target}>
																<GreenPhoxIcon
																	isActive={item.id === 'green-phox'}
																	name={item.name}
																	icon={item.icon}
																/>
															</Link>
														</li>
												}
											</React.Fragment>
									)
								})
							}
						</ul>
						<ul className='navbar-nav'>
							<li className='nav-item'>
								<Link className='nav-link' target="_blank" to={"https://help.desk.phoxhealth.com/"}>
									<i className={`fe fe-life-buoy nav-item`}></i> {"Help Center"}
								</Link>
							</li>
							<li className='nav-item'>
								<Link className='nav-link' target="_self" to={"/changelog"}>
									<i className={`fe fe-git-branch nav-item`}></i> {"Changelog"}<span class="badge bg-primary ms-auto">v{packageJson?.version || ""}</span>
								</Link>
							</li>
							<li className='nav-item'>
								<Link to='/profile' className='nav-link'><i className={`fe fe-settings nav-item`}></i>My Profile</Link>
							</li>
							<li className='nav-item'>
								<Link to='/auth/logout' className='nav-link'><i className={`fe fe-log-out nav-item`}></i>Logout</Link>
							</li>
						</ul>
					</div>
					{
						showTimer &&
						<>
							<div className='d-flex justify-content-center'>
								<h5 className='text-danger'>You will be logged out in</h5>
							</div>
							<div className='d-flex justify-content-center'>
								<h3 className='text-danger'>  <b> {seconds} s </b>  </h3>
							</div>
							<hr />
						</>
					}
					{/* {
						packageJson?.version &&
						<div className='d-flex justify-content-center text-muted align-item-center'>
							<small> v{packageJson?.version} </small>
						</div>
					} */}
				</div>
			</nav>
			<Modal show={versionUpdateModal} size="lg" aria-labelledby="contained-modal-title-vcenter" onHide={() => showVersionUpdateModal(false)} centered className="version-update-modal">
				<div className="position-relative text-white text-center py-5 "
					style={{ background: "radial-gradient(circle, #092942 10%, #041E32 80%)", height: "180px", borderRadius: "30px" }}>
					{/* Stars Background Image */}
					<div
						className="position-absolute top-0 start-0 w-100 h-100"
						style={{ backgroundImage: "url('./img/stars.png')", backgroundSize: "cover", backgroundPosition: "bottom-center", opacity: "1", }}

					>
					</div>
					<svg
						style={{ border: "none" }}
						className="position-absolute bottom-0 start-0 w-100"
						height="60"
						viewBox="0 0 1440 320"
						preserveAspectRatio="none"
						xmlns="http://www.w3.org/2000/svg"
						fill="white"
					>
						<path d="M0,0 Q720,200 1440,0 L1440,320 L0,320 Z"></path>
					</svg>
					<div
						className="position-absolute start-50 translate-middle-x align-items-center d-flex"
						style={{ width: "125px", height: "125px", borderRadius: "50%", background: "radial-gradient(circle, #103A58 10%, #06182C 80%)", bottom: "-10px" }}
					>
						<img
							src="./img/phoxLogo.png"
							alt="Rocket"
							className="position-absolute start-50 translate-middle-x d-flex justify-content-center align-items-center"
							style={{ width: '50px' }}
						/>
					</div>
				</div>
				<Modal.Body>
					{updates.length > 0 && (
						(() => {
							const latestUpdate = updates[0];
							return (
								<div className=''>
									<div className='d-flex  justify-content-center '>
										<span class=" ms-3 badge text-black fs-4" style={{ backgroundColor: "#FFF1E6" }}>Version {latestUpdate.version}</span>
										<span class=" ms-3 badge text-black fs-4" style={{ backgroundColor: "#FFF1E6" }}>Release Date: {latestUpdate.date}</span>
									</div>
									<div className='d-flex justify-content-center'>
										<h1 className="ml-3 mt-3" style={{ fontSize: "35px" }}>
											We're getting <span className="font-weight-bold" style={{ color: "#FF7200" }}>better!</span>
										</h1>
									</div>
									<div className="mt-3">
										<p className='d-flex justify-content-start ms-4'>
											<strong>Phox OS {latestUpdate.version}</strong>
										</p>
										{Array.isArray(latestUpdate?.updates) && latestUpdate.updates.map((update, updateIndex) => (
											<div key={updateIndex} className="mt-3">
												{/* Header */}
												{update?.header && (
													<h4 className="fw-semibold">{update.header}</h4>
												)}

												{/* SubHeader */}
												{update?.subHeader && (
													<p className="fw-light mb-2">
														{update.subHeader}
													</p>
												)}

												{/* points */}
												{Array.isArray(update?.points) && update.points.map((menu, menuIndex) => (
													<ul key={menuIndex} className="ps-4 mb-3">
														<li>
															{menu?.title && <strong>{menu.title}:</strong>} {menu?.description}

															{/* Subpoints */}
															{Array.isArray(menu?.subpoints) && menu.subpoints.length > 0 && (
																<ul className="ps-3 mt-2">
																	{menu.subpoints.map((submenu, subIndex) => (
																		<li key={subIndex} className="list-circle">
																			{submenu?.title && <strong>{submenu.title}:</strong>} {submenu?.description}
																		</li>
																	))}
																</ul>
															)}
														</li>
													</ul>
												))}
											</div>
										))}
									</div>
									<div className='d-flex justify-content-center mt-4'>
										<button className='btn btn-md btn-dark px-4 me-3'

											onClick={() => showVersionUpdateModal(false)}>
											Continue
										</button>
										<button className='btn btn-md btn px-4 text-black' style={{ backgroundColor: "#EDF2F9" }}
											onClick={() => { navigate("/changelog"); showVersionUpdateModal(false); }}>
											Learn more
										</button>

									</div>
								</div>
							);
						})()
					)}
				</Modal.Body>
			</Modal>


		</>
	)
}



